import { useEffect, useState } from 'react';
import { Row, Col, InputGroup } from 'react-bootstrap';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import TextInput from 'src/Admin/components/common/text-input';
//import AutoSuggestionSelectComponent from '../../common/auto-suggestion-select/Select';
import AutoSuggestionSelectComponent from '../../common/AutoSuggestSelect/Select';
import FullWidthFilterBar from 'src/Components/FullWidthFilterBar';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';

//const requestTypeOptions = [
//{ label: 'Open Enrollment', value: 'Open Enrollment' },
//{ label: 'New Hire', value: 'New Hire' },
//{ label: 'Life Event', value: 'Life Event' },
//];

const SearchResultsFilterBar = ({
  onSearch,
  searchText,
  search,
  selectedTabLocal,
  setAffiliationData,
  setTotalRecords,
  currentPage,
  pageSize,
  setIsAPIFailed,
  activeStatusFilter,
  resetFilterSection,
  requestType,
  setRequestType,
  sorted,
  sortCategory,
  setDataFetching,
  dataFetching,
  isNotFound,
  setIsNotFound,
}) => {
  //const [searchText, setSearchText] = useState('');
  const [requestTypeOptions, setRequestTypeOptions] = useState([]);
  //const [requestType, setRequestType] = useState([]);

  const requestTypeCategoryValues = [
    { label: 'Registration', value: 'Registration' },
    { label: 'Self Affiliation', value: 'Self Affiliation' },
  ];

  const requestTypeList = async () => {
    try {
      const responseTypeCategory = await axiosInstance.get(
        APIEndpoints.getRequestTypeForEnrollment(),
      );
      const typeListData =
        responseTypeCategory?.data?.Response
          ?.worklistConfigMasterResponseDTOList;
      const typeCategoryValues = typeListData.map((item) => {
        return {
          label: item?.SubCategory,
          value: item?.Oid,
        };
      });
      const tempTypeCategoryValues = [
        { label: 'Registration', value: 'registration' },
        { label: 'Self Affiliation', value: 'selfAffiliation' },
      ];
      setRequestTypeOptions(
        selectedTabLocal !== 'memberRegistration'
          ? typeCategoryValues
          : tempTypeCategoryValues,
      );
    } catch (err) {
      console.log('err :', err);
    }
  };

  const requestTypeValue = requestType && requestType.value;

  const fetchEnrollmentAffiliation = async () => {
    setDataFetching(true);
    setIsAPIFailed(false);
    setIsNotFound(false);
    try {
      const affliationStatus = activeStatusFilter
        ? activeStatusFilter !== 'allrequest'
          ? activeStatusFilter === 'Pending'
            ? '/status/Active'
            : `/status/${activeStatusFilter}`
          : ''
        : '';
      const response = await axiosInstance.get(
        APIEndpoints.getRequestTypeForEnrollmentAffiliation() +
          affliationStatus +
          `/pagenumber/${currentPage}` +
          `/pagesize/${pageSize}` +
          `${
            searchText && searchText !== '' ? `/searchkey/${searchText}` : ''
          }` +
          `${requestTypeValue ? `/requesttype/${requestTypeValue}` : ''}` +
          `${
            sortCategory && sortCategory !== '' ? `/sortby/${sortCategory}` : ''
          }` +
          `${sorted && sorted !== '' ? `/sortdirection/${sorted}` : ''}`,
      );
      const responseData = response?.data?.Response?.workListMasterDTOList;
      console.log('responseData', responseData);
      const data =
        responseData &&
        responseData.map((item) => {
          return {
            firstName: item?.DualCoverageUserDetailsDTO?.FirstName,
            LastName: item?.DualCoverageUserDetailsDTO?.LastName,
            affiliateemployer: item?.DualCoverageUserDetailsDTO
              ?.DualCoverageAffiliation?.length
              ? `${
                  item?.DualCoverageUserDetailsDTO?.DualCoverageAffiliation[0]
                    .Employername
                } ${
                  item?.DualCoverageUserDetailsDTO?.DualCoverageAffiliation
                    ?.length > 1
                    ? `(+${
                        item?.DualCoverageUserDetailsDTO
                          ?.DualCoverageAffiliation?.length - 1
                      })`
                    : ''
                }`
              : null,
            userid: item?.DualCoverageUserDetailsDTO?.UserID,
            subcategory: item?.Subcategory,
            createddate: item?.createddate,
            status:
              item?.status === 'Active' ? 'Pending Approval' : item?.status,
            Oid: item?.Oid,
          };
        });
      setAffiliationData(data);
      setTotalRecords(response?.data?.Response?.Pagination?.TotalRecords);
      setDataFetching(false);
      setIsAPIFailed(false);
      setIsNotFound(false);
    } catch (error) {
      console.log('err :', error);
      setDataFetching(false);
      setIsAPIFailed(true);
      if (error.response.status === 404) {
        setAffiliationData([]);
        setIsNotFound(true);
      }
    }
  };

  useEffect(() => {
    selectedTabLocal === 'affiliation' &&
      setRequestTypeOptions(requestTypeCategoryValues);
  }, [selectedTabLocal]);

  useEffect(() => {
    if (!requestTypeOptions?.length && selectedTabLocal === 'enrollment') {
      requestTypeList();
    }
  }, [selectedTabLocal]);

  useEffect(() => {
    if (selectedTabLocal === 'affiliation') {
      fetchEnrollmentAffiliation();
    }
  }, [
    selectedTabLocal,
    currentPage,
    pageSize,
    activeStatusFilter,
    search,
    requestTypeValue,
    sorted,
    sortCategory,
  ]);

  const onChangeSearchText = (e) => {
    onSearch(e);
  };
  return (
    <FullWidthFilterBar>
      <div className="search-container-filter">
        <Row className="justify-content-between">
          <Col
            xs={12}
            sm={6}
            md={4}
            lg={4}
            className="filter-bar-border-right py-3"
          >
            {/*<label htmlFor="filterByTitleReference" className="sr-only">
              Search by Provider, NPI or Tax ID
            </label> */}
            <TextInput
              parentClassName="document-search"
              append={
                <InputGroup.Text>
                  <SearchSVG.SearchSVG className="primary-text-color" />
                </InputGroup.Text>
              }
              inputProps={{
                type: 'text',
                placeholder: 'Search by Member',
                className: 'border-0 height-32',
                value: searchText,
                onChange: onChangeSearchText,
                id: 'filterByTitleReference',
              }}
            />
          </Col>
          <Col lg={3} md={3} className="Sort_by_option px-0 py-3 pl-3">
            <div className="filter-data1 d-flex gap-3 align-items-center">
              <div>
                <span className="dropdown_label">Request Type:</span>
              </div>
              <div className="type_category_select">
                <AutoSuggestionSelectComponent
                  options={requestTypeOptions}
                  components={{ IndicatorSeparator: () => null }}
                  value={requestType}
                  onChange={(e) => {
                    console.log(e);
                    setRequestType(e);
                  }}
                  isSearchable={false}
                  inputClassName="height-32 select-without-border"
                  aria-labelledby="forsortby"
                  onFocus={() => {}}
                />
              </div>
            </div>
          </Col>

          <Col
            xs={12}
            sm={6}
            md={4}
            lg={5}
            className="send-document-button py-4"
          >
            <div className="d-flex justify-content-end">
              {/*<div className="messaging-reset pr-4" onClick={() => {}}>
                Reset Filter
              </div> */}
              <GenericButton
                variant="link"
                className="p-0 m-0"
                onClick={() => {
                  resetFilterSection();
                }}
              >
                Reset Filter
              </GenericButton>
            </div>
          </Col>
        </Row>
      </div>
    </FullWidthFilterBar>
  );
};

export default SearchResultsFilterBar;
